<script>
import MyCustomComp from '../src/components/MyCustomComp.vue';
export default {
  name: 'whatever',
  components: {
    MyCustomComp: MyCustomComp
  },
  frontmatter: JSON.parse('{"componentName":"whatever"}')
};
</script>

<template>
  <div>
    <h2 style="color: DarkViolet;">Registered Vue Component</h2>
<p>Check out the demo below:</p>
<p>frontmatter: {{ $options.frontmatter }}</p>
<p>Here, We have a <strong>MyCustomComp.vue</strong> file correspond to <strong><code>&#x3C;my-custom-comp>&#x3C;/my-custom-comp></code></strong> in Markdown file</p>
<p><global></global></p>
<p><my-custom-comp></my-custom-comp></p>
  </div>
</template>


